import React, { useContext, useEffect, useState } from 'react';
import { Container, Table, Button, Row, Col, Input, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, InputGroup } from 'reactstrap';
import PaginationMaterial from "../../components/PaginationMaterial/PaginationMaterial";
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import Header from '../../components/Headers/Header';
import AdminNavbar from '../../components/Navbars/AdminNavbar/AdminNavbar';
import { AuthContext } from '../../context/AuthContext';
import { PreparacaoAlbumContext } from '../../context/PreparacaoAlbumContext';
import { CursoContext } from '../../context/CursoContext';
import { TerceiroContext } from '../../context/TerceiroContext';
import { ContratoContext } from '../../context/ContratoContext';
import { PreparacaoAlbumType, CreatePreparacaoAlbumType, EditPreparacaoAlbumType } from '../../context/hooks/usePreparacaoAlbum';

import { CreateTerceiroModal } from '../../components/Terceiro/CreateTerceiroModal';
import { EditTerceiroModal } from '../../components/Terceiro/EditTerceiroModal';

import useUser from '../../context/hooks/useUser';
import { createPermissionChecker, PermissionModule } from '../../types/permissions';

const PreparacaoAlbum = () => {
    const { objUserTk } = useContext(AuthContext);
    const { handleGetCursoByContratoId, listCursoByContrato, setListCursoByContrato } = useContext(CursoContext);
    const { getPreparacaoAlbumPaged, listPreparacaoAlbum, preparacaoAlbumPageCount, createPreparacaoAlbum, updatePreparacaoAlbum, deletePreparacaoAlbum, updateStatusPreparacaoAlbum, exportPreparacaoAlbumPdf } = useContext(PreparacaoAlbumContext);
    const { getTerceiroPaged, handleGetEditorsByEmpresa, listEditor, handleGetLaboratoriesByEmpresa, listLaboratory } = useContext(TerceiroContext);
    const { handleGetContratoByEmpresaId, listContrato } = useContext(ContratoContext);
    const [loaging, setLoading] = useState(true);
    const { getPermissionsByUser, userPermissions, useLegacyPermissions, modulePermissions } = useUser();
    const hasPermission = createPermissionChecker(useLegacyPermissions, userPermissions, modulePermissions);
    const [newPreparacaoAlbum, setNewPreparacaoAlbum] = useState<CreatePreparacaoAlbumType>({
        description: "",
        numberOfPhotos: 0,
        numberOfPhotosLaboratory: 0,
        numberOfAlbums: 0,
        editorDeliveryDate: "",
        editorReturnDate: "",
        laboratoryDeliveryDate: "",
        laboratoryReturnDate: "",
        kit30x60: false,
        kit30x60Quantities: 0,
        kit10x15: false,
        kit10x15Quantities: 0,
        kit28x35: false,
        kit28x35Quantities: 0,
        status: 0,
        empresaId: 0,
        contratoId: 0,
        editorId: 0,
        laboratorioId: 0,
    });
    const [editingPreparacaoAlbum, setEditingPreparacaoAlbum] = useState<EditPreparacaoAlbumType | null>(null);

    const [dataSearch, setDataSearch] = useState({ ContratoId: 0, EditorId: 0, LaboratorioId: 0, Status: 0, InitialDate: "", FinalDate: "" });

    const [createModalOpen, setCreateModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);

    const [createEditorModalOpen, setCreateEditorModalOpen] = useState(false);
    const [createLabModalOpen, setCreateLabModalOpen] = useState(false);

    useEffect(() => {
        setLoading(true);

        getTerceiroPaged(1, "", objUserTk.EmpresaId, 1000, "FOTÓGRAFO");
        handleGetEditorsByEmpresa(objUserTk.EmpresaId);
        handleGetLaboratoriesByEmpresa(objUserTk.EmpresaId);
        handleGetContratoByEmpresaId(objUserTk.EmpresaId);

        getPreparacaoAlbumPaged(1, objUserTk?.EmpresaId, 0, 9)
            .then(data => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao buscar albuns:", error);
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        const fetchPermissions = async () => {
            if (objUserTk?.UserId) {
                const permissions = await getPermissionsByUser(objUserTk.UserId);
            }
        };

        fetchPermissions().catch(error => console.error("Erro ao carregar permissões:", error));
    }, [objUserTk?.UserId]);

    const onChangePaginationCommon = async (e: any, value: any) => {
        await getPreparacaoAlbumPaged(value, objUserTk.EmpresaId, dataSearch.ContratoId, 9, dataSearch.EditorId, dataSearch.LaboratorioId, dataSearch.Status, dataSearch.InitialDate, dataSearch.FinalDate);
    };

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDataSearch({ ...dataSearch, [e.target.name]: e.target.value });
    };

    const handleClearFilters = () => {
        setDataSearch({ ContratoId: 0, EditorId: 0, LaboratorioId: 0, Status: 0, InitialDate: "", FinalDate: "" });
        setLoading(true);
        getPreparacaoAlbumPaged(1, objUserTk?.EmpresaId, 0, 9)
            .then(() => setLoading(false))
            .catch(() => setLoading(false));
    };

    const handleSearchSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setLoading(true);
        getPreparacaoAlbumPaged(1, objUserTk?.EmpresaId, dataSearch.ContratoId, 9, dataSearch.EditorId, dataSearch.LaboratorioId, dataSearch.Status, dataSearch.InitialDate, dataSearch.FinalDate)
            .then(() => setLoading(false))
            .catch(() => setLoading(false));
    };

    //--------------------------------------------

    const formatPreparacaoAlbumData = (preparacaoAlbum: any) => ({
        ...preparacaoAlbum,
        numberOfPhotos: Number(preparacaoAlbum.numberOfPhotos),
        numberOfPhotosLaboratory: Number(preparacaoAlbum.numberOfPhotosLaboratory),
        numberOfAlbums: Number(preparacaoAlbum.numberOfAlbums),
        editorDeliveryDate: preparacaoAlbum.editorDeliveryDate ? preparacaoAlbum.editorDeliveryDate : null,
        editorReturnDate: preparacaoAlbum.editorReturnDate ? preparacaoAlbum.editorReturnDate : null,
        laboratoryDeliveryDate: preparacaoAlbum.laboratoryDeliveryDate ? preparacaoAlbum.laboratoryDeliveryDate : null,
        laboratoryReturnDate: preparacaoAlbum.laboratoryReturnDate ? preparacaoAlbum.laboratoryReturnDate : null,
        kit30x60: preparacaoAlbum.kit30x60 ? preparacaoAlbum.kit30x60 : false,
        kit30x60Quantities: Number(preparacaoAlbum.kit30x60Quantities),
        kit10x15: preparacaoAlbum.kit10x15 ? preparacaoAlbum.kit10x15 : false,
        kit10x15Quantities: Number(preparacaoAlbum.kit10x15Quantities),
        kit28x35: preparacaoAlbum.kit28x35 ? preparacaoAlbum.kit28x35 : false,
        kit28x35Quantities: Number(preparacaoAlbum.kit28x35Quantities),
        empresaId: objUserTk?.EmpresaId || 0,
        contratoId: Number(preparacaoAlbum.contratoId),
        editorId: Number(preparacaoAlbum.editorId),
        laboratorioId: Number(preparacaoAlbum.laboratorioId),
        cursoId: listCursoByContrato.map((curso) => curso.id),
    });

    const handleCreateInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, type, checked } = e.target;
        if (type === 'checkbox') {
            setNewPreparacaoAlbum(prevPreparacaoAlbum => ({
                ...prevPreparacaoAlbum,
                [name]: checked,
            }));
        } else {
            setNewPreparacaoAlbum(prevPreparacaoAlbum => ({
                ...prevPreparacaoAlbum,
                [name]: value,
            }));
        }
    };

    const handleCreatePreparacaoAlbum = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const formattedData = formatPreparacaoAlbumData(newPreparacaoAlbum);

        createPreparacaoAlbum(formattedData)
            .then(createdPreparacaoAlbum => {
                if (createdPreparacaoAlbum) {
                    setCreateModalOpen(false);
                    setNewPreparacaoAlbum({
                        description: "",
                        numberOfPhotos: 0,
                        numberOfPhotosLaboratory: 0,
                        numberOfAlbums: 0,
                        editorDeliveryDate: "",
                        editorReturnDate: "",
                        laboratoryDeliveryDate: "",
                        laboratoryReturnDate: "",
                        kit30x60: false,
                        kit30x60Quantities: 0,
                        kit10x15: false,
                        kit10x15Quantities: 0,
                        kit28x35: false,
                        kit28x35Quantities: 0,
                        status: 0,
                        empresaId: 0,
                        contratoId: 0,
                        editorId: 0,
                        laboratorioId: 0,
                    });
                    getPreparacaoAlbumPaged(1, objUserTk?.EmpresaId, 0, 9)
                } else {
                    console.error("Erro ao criar álbum.");
                }
            })
            .catch(error => {
                console.error("Erro ao criar álbum:", error);
            });
    };


    const handleEditInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, type, checked } = e.target;;
        setEditingPreparacaoAlbum(prevPreparacaoAlbum => ({
            ...prevPreparacaoAlbum!,
            [name]: type === 'checkbox' ? checked : value,
        }));
    }

    const handleEditPreparacaoAlbum = async (preparacaoAlbum: PreparacaoAlbumType) => {
        const updateData: EditPreparacaoAlbumType = {
            id: preparacaoAlbum.id,
            description: preparacaoAlbum.description,
            numberOfPhotos: preparacaoAlbum.numberOfPhotos,
            numberOfPhotosLaboratory: preparacaoAlbum.numberOfPhotosLaboratory,
            numberOfAlbums: preparacaoAlbum.numberOfAlbums,
            editorDeliveryDate: preparacaoAlbum.editorDeliveryDate,
            editorReturnDate: preparacaoAlbum.editorReturnDate,
            laboratoryDeliveryDate: preparacaoAlbum.laboratoryDeliveryDate,
            laboratoryReturnDate: preparacaoAlbum.laboratoryReturnDate,
            kit30x60: preparacaoAlbum.kit30x60,
            kit30x60Quantities: preparacaoAlbum.kit30x60Quantities,
            kit10x15: preparacaoAlbum.kit10x15,
            kit10x15Quantities: preparacaoAlbum.kit10x15Quantities,
            kit28x35: preparacaoAlbum.kit28x35,
            kit28x35Quantities: preparacaoAlbum.kit28x35Quantities,
            status: preparacaoAlbum.status,
            empresaId: objUserTk?.EmpresaId || 0,
            contratoId: preparacaoAlbum.contratoId,
            editorId: preparacaoAlbum.editorId,
            laboratorioId: preparacaoAlbum.laboratorioId,
            cursos: preparacaoAlbum.cursos,
        };
        setEditingPreparacaoAlbum(updateData);

        await getPreparacaoAlbumPaged(1, objUserTk?.EmpresaId, 0, 9);

        setEditModalOpen(true);
    };

    const handleEditSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (editingPreparacaoAlbum) {
            // let statusAtualizado = editingPreparacaoAlbum.status;

            // if ((editingPreparacaoAlbum?.editorId ?? 0) > 0) {
            //     if ((editingPreparacaoAlbum?.laboratorioId ?? 0) > 0) {
            //         statusAtualizado = 4;
            //     } else {
            //         statusAtualizado = 3;
            //     }
            // }

            const updatedData: EditPreparacaoAlbumType = {
                ...editingPreparacaoAlbum,
                // status: statusAtualizado,
            };

            updatePreparacaoAlbum(updatedData)
                .then(updatedPreparacaoAlbum => {
                    if (updatedPreparacaoAlbum) {
                        setEditModalOpen(false);
                        getPreparacaoAlbumPaged(1, objUserTk?.EmpresaId, 0, 9);
                    } else {
                        console.error("Erro ao atualizar álbum.");
                    }
                })
                .catch(error => {
                    console.error("Erro ao atualizar álbum:", error);
                });
        }
    };

    const handleDeletePreparacaoAlbum = (preparacaoAlbumId: number) => {
        if (window.confirm("Tem certeza que deseja excluir este álbum?")) {
            deletePreparacaoAlbum(preparacaoAlbumId)
                .then(() => {
                    console.log("Álbum excluído com sucesso");
                    setTimeout(() => {
                        getPreparacaoAlbumPaged(1, objUserTk?.EmpresaId, 0, 9);
                    }, 500);
                })
                .catch(error => {
                    console.error("Erro ao excluir álbum:", error);
                });
        }
    };

    const getStatusLabel = (status: number) => {
        switch (status) {
            case 1:
                return "Aberto";
            case 2:
                return "Em andamento";
            case 3:
                return "Em edição";
            case 4:
                return "Em laboratório";
            case 5:
                return "Aguardando venda";
            case 6:
                return "Finalizado";
            default:
                return "Desconhecido";
        }
    };

    const handleContratoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const contratoId = Number(e.target.value);

        setNewPreparacaoAlbum(prev => ({
            ...prev,
            contratoId: contratoId
        }));

        if (contratoId > 0) {
            handleGetCursoByContratoId(contratoId);
        } else {
            setListCursoByContrato([]);
        }
    };

    function resetCampos() {
        setNewPreparacaoAlbum({
            description: "",
            numberOfPhotos: 0,
            numberOfPhotosLaboratory: 0,
            numberOfAlbums: 0,
            editorDeliveryDate: "",
            editorReturnDate: "",
            laboratoryDeliveryDate: "",
            laboratoryReturnDate: "",
            kit30x60: false,
            kit30x60Quantities: 0,
            kit10x15: false,
            kit10x15Quantities: 0,
            kit28x35: false,
            kit28x35Quantities: 0,
            status: 0,
            empresaId: 0,
            contratoId: 0,
            editorId: 0,
            laboratorioId: 0,
        });
        setEditingPreparacaoAlbum(null);
        setListCursoByContrato([]);
    }

    const handleExportPdf = () => {
        exportPreparacaoAlbumPdf({
            EmpresaId: objUserTk?.EmpresaId,
            ContratoId: dataSearch.ContratoId,
            EditorId: dataSearch.EditorId,
            LaboratorioId: dataSearch.LaboratorioId,
            Status: dataSearch.Status,
            InitialDate: dataSearch.InitialDate,
            FinalDate: dataSearch.FinalDate
        });
    };

    if (loaging) {
        return <LoadingSpinner />;
    }

    return (
        <>
            <LoadingSpinner />
            <Header />
            <AdminNavbar
                brandText={"Gerenciar preparações de álbuns"}
                search={false}
                titleSearch={""}
            />

            <Container className="mt-5">
                <Form onSubmit={handleSearchSubmit}>
                    <Row className="align-items-center mb-4">
                        <Col xs="12" md="3" lg="3" className="mb-2">
                            <Label className="form-control-label" for="description">Número do Contrato</Label>
                            <Input
                                className="form-control-alternative"
                                type="number"
                                name="ContratoId"
                                id="ContratoId"
                                placeholder="Buscar por número do contrato"
                                value={dataSearch.ContratoId}
                                onChange={handleSearchChange}
                            />
                        </Col>
                        <Col xs="12" md="3" lg="3" className="mb-2">
                            <Label className="form-control-label" for="editorId">Editor</Label>
                            <Input
                                className="form-control-alternative"
                                type="select"
                                name="EditorId"
                                id="EditorId"
                                value={dataSearch.EditorId}
                                onChange={handleSearchChange}
                            >
                                <option value={0}>Selecione um Editor</option>
                                {listEditor.map((editor) => (
                                    <option key={editor.id} value={editor.id}>
                                        {editor.name}
                                    </option>
                                ))}
                            </Input>
                        </Col>
                        <Col xs="12" md="3" lg="3" className="mb-2">
                            <Label className="form-control-label" for="laboratorioId">Laboratório</Label>
                            <Input
                                className="form-control-alternative"
                                type="select"
                                name="LaboratorioId"
                                id="LaboratorioId"
                                value={dataSearch.LaboratorioId}
                                onChange={handleSearchChange}
                            >
                                <option value={0}>Selecione um Laboratório</option>
                                {listLaboratory.map((lab) => (
                                    <option key={lab.id} value={lab.id}>
                                        {lab.name}
                                    </option>
                                ))}
                            </Input>
                        </Col>
                        <Col xs="12" md="3" lg="3" className="mb-2">
                            <Label className="form-control-label" for="status">Status</Label>
                            <Input
                                className="form-control-alternative"
                                type="select"
                                name="Status"
                                id="Status"
                                value={dataSearch.Status}
                                onChange={handleSearchChange}
                            >
                                <option value={0}>Selecione um Status</option>
                                <option value={1}>Aberto</option>
                                <option value={2}>Em andamento</option>
                                <option value={3}>Em edição</option>
                                <option value={4}>Em laboratório</option>
                                <option value={5}>Finalizado</option>
                            </Input>
                        </Col>
                        <Col xs="12" md="3" lg="3" className="mb-2">
                            <Label className="form-control-label" for="InitialDate">Data Inicial</Label>
                            <Input
                                className="form-control-alternative"
                                type="date"
                                name="InitialDate"
                                id="InitialDate"
                                value={dataSearch.InitialDate}
                                onChange={handleSearchChange}
                            />
                        </Col>
                        <Col xs="12" md="3" lg="3" className="mb-2">
                            <Label className="form-control-label" for="FinalDate">Data Final</Label>
                            <Input
                                className="form-control-alternative"
                                type="date"
                                name="FinalDate"
                                id="FinalDate"
                                value={dataSearch.FinalDate}
                                onChange={handleSearchChange}
                            />
                        </Col>
                        <Col xs="12" md="6" lg="6" className="d-flex justify-content-start justify-content-md-end mb-2">
                            <Button style={{ color: "#FFF", backgroundColor: "#585858" }} type="submit" size="m">Buscar</Button>
                            <Button
                                style={{ color: "#FFF", backgroundColor: "#d9534f" }}
                                type="button"
                                size="m"
                                onClick={handleClearFilters}
                            >
                                Limpar
                            </Button>
                        </Col>
                        {hasPermission(PermissionModule.PreparacaoAlbuns, 1) && (
                            <Col xs="12" className="text-right mt-3">
                                <Button
                                    style={{ backgroundColor: '#007bff', color: '#FFF' }}
                                    onClick={handleExportPdf}
                                >
                                    <i className="fa-solid fa-file-pdf mr-2"></i> Exportar PDF
                                </Button>
                                <Button
                                    style={{ color: "#FFF", backgroundColor: "#585858" }}
                                    size="m"
                                    onClick={() => { setCreateModalOpen(true); resetCampos(); }}
                                >
                                    Adicionar preparação
                                </Button>
                            </Col>
                        )}
                    </Row>
                </Form>
                {hasPermission(PermissionModule.PreparacaoAlbuns, 2) ? (
                    <Row className="mt-4">
                        <Col>
                            <Table hover responsive className="table-striped">
                                <thead>
                                    <tr>
                                        <th>Nº Contrato</th>
                                        <th>Sequência</th>
                                        <th>Descrição</th>
                                        <th>Cursos</th>
                                        <th>Fotos Editor</th>
                                        <th>Entrega Editor</th>
                                        <th>Retorno Editor</th>
                                        <th>Fotos Laboratório</th>
                                        <th>Álbuns</th>
                                        <th>Entrega Lab</th>
                                        <th>Retorno Lab</th>
                                        <th>Status</th>
                                        <th>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {listPreparacaoAlbum.map(item => (
                                        <tr key={item.id}>
                                            <td>{item.contratoId}</td>
                                            <td>{item.id}</td>
                                            <td>{item.description}</td>
                                            <td>
                                                {item.cursos?.length ? (
                                                    item.cursos.map((curso) => curso.name).join(", ")
                                                ) : (
                                                    "Nenhum curso"
                                                )}
                                            </td>
                                            <td>{item.numberOfPhotos}</td>
                                            <td>{item.editorDeliveryDate ? item.editorDeliveryDate : "Data ainda não definida"}</td>
                                            <td>{item.editorReturnDate ? item.editorReturnDate : "Data ainda não definida"}</td>
                                            <td>{item.numberOfPhotosLaboratory}</td>
                                            <td>{item.numberOfAlbums}</td>
                                            <td>{item.laboratoryDeliveryDate ? item.laboratoryDeliveryDate : "Data ainda não definida"}</td>
                                            <td>{item.laboratoryReturnDate ? item.laboratoryReturnDate : "Data ainda não definida"}</td>
                                            <td>{getStatusLabel(Number(item.status))}</td>
                                            <td>
                                                <Button onClick={() => handleEditPreparacaoAlbum(item)}><i className="fa-solid fa-pen-to-square"></i></Button>
                                                <Button onClick={() => handleDeletePreparacaoAlbum(item.id)} color="danger"><i className="fa-solid fa-trash"></i></Button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                            <div className="d-flex justify-content-end mt-3">
                                {preparacaoAlbumPageCount && (
                                    <div className="d-flex justify-content-center mt-4">
                                        <PaginationMaterial
                                            onChange={(e: any, value: any) => onChangePaginationCommon(e, value)}
                                            count={preparacaoAlbumPageCount}
                                        />
                                    </div>
                                )}
                                {listPreparacaoAlbum.length === 0 && (
                                    <div style={{ color: "red" }}>NÃO FOI ENCONTRADO NENHUM REGISTRO</div>
                                )}
                            </div>
                        </Col>
                    </Row>
                ) : (
                    <Row className="mt-4">
                        <Col>
                            <div style={{ color: "red", textAlign: "center" }}>
                                Você não tem permissão para visualizar as prepações.
                            </div>
                        </Col>
                    </Row>
                )}
            </Container>

            <Modal isOpen={createModalOpen} toggle={() => {
                setCreateModalOpen(!createModalOpen);
            }} backdrop="static" size="xl">
                <ModalHeader toggle={() => setCreateModalOpen(!createModalOpen)}>Adicionar Preparação de Álbum</ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleCreatePreparacaoAlbum}>
                        <Row>
                            <Col md="12">
                                <FormGroup>
                                    <Label className="form-control-label" htmlFor="description">
                                        Descrição
                                    </Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="text"
                                        name="description"
                                        id="description"
                                        value={newPreparacaoAlbum.description}
                                        onChange={handleCreateInputChange}
                                        placeholder="Ex: Álbum infantil 2023"
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-control-label" htmlFor="contratoId">
                                        Contrato
                                    </Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="select"
                                        name="contratoId"
                                        id="contratoId"
                                        value={newPreparacaoAlbum.contratoId}
                                        onChange={handleContratoChange}
                                    >
                                        <option value={0}>Selecione um Contrato</option>
                                        {listContrato.map((contrato) => (
                                            <option key={contrato.id} value={contrato.id}>
                                                {`${contrato.id} - ${contrato.description}`}
                                            </option>
                                        ))}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-control-label" htmlFor="numberOfAlbums">
                                        Cursos do Contrato
                                    </Label>
                                    <div className="mt-2">
                                        {listCursoByContrato.map((curso) => (
                                            <span key={curso.id} className="badge badge-primary mr-2">
                                                {curso.name}
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-danger ml-1"
                                                    onClick={() => {
                                                        const novoArray = listCursoByContrato.filter((c) => c.id !== curso.id);
                                                        setListCursoByContrato(novoArray);
                                                    }}
                                                >
                                                    x
                                                </button>
                                            </span>
                                        ))}
                                    </div>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="4">
                                <FormGroup>
                                    <Label className="form-control-label" htmlFor="editorId">Editor</Label>
                                    <InputGroup>
                                        <Input
                                            className="form-control-alternative"
                                            type="select"
                                            name="editorId"
                                            id="editorId"
                                            value={newPreparacaoAlbum.editorId}
                                            onChange={handleCreateInputChange}
                                        >
                                            <option value={0}>Selecione um Editor</option>
                                            {listEditor.map((editor) => (
                                                <option key={editor.id} value={editor.id}>
                                                    {editor.name}
                                                </option>
                                            ))}
                                        </Input><Button
                                                style={{ background: '#585858', color: '#fff' }}
                                                onClick={() => setCreateEditorModalOpen(true)}
                                            >
                                                +
                                            </Button></InputGroup>
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup>
                                    <Label className="form-control-label" htmlFor="editorDeliveryDate">
                                        Entrega para o editor
                                    </Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="date"
                                        name="editorDeliveryDate"
                                        id="editorDeliveryDate"
                                        value={newPreparacaoAlbum.editorDeliveryDate?.toString() || ""}
                                        onChange={handleCreateInputChange}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup>
                                    <Label className="form-control-label" htmlFor="editorReturnDate">
                                        Retorno do Editor
                                    </Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="date"
                                        name="editorReturnDate"
                                        id="editorReturnDate"
                                        value={newPreparacaoAlbum.editorReturnDate?.toString() || ""}
                                        onChange={handleCreateInputChange}
                                        disabled={newPreparacaoAlbum.editorId === 0}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12">
                                <FormGroup>
                                    <Label className="form-control-label" htmlFor="numberOfPhotos">
                                        Nº de Fotos do Editor
                                    </Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="number"
                                        name="numberOfPhotos"
                                        id="numberOfPhotos"
                                        value={newPreparacaoAlbum.numberOfPhotos}
                                        onChange={handleCreateInputChange}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="4">
                                <FormGroup>
                                    <Label className="form-control-label" htmlFor="laboratorioId">
                                        Laboratório
                                    </Label>
                                    <InputGroup>
                                        <Input
                                            className="form-control-alternative"
                                            type="select"
                                            name="laboratorioId"
                                            id="laboratorioId"
                                            value={newPreparacaoAlbum.laboratorioId}
                                            onChange={handleCreateInputChange}
                                            disabled={!newPreparacaoAlbum.editorReturnDate}
                                        >
                                            <option value={0}>Selecione um Laboratório</option>
                                            {listLaboratory.map((lab) => (
                                                <option key={lab.id} value={lab.id}>
                                                    {lab.name}
                                                </option>
                                            ))}
                                        </Input><Button
                                                style={{ background: '#585858', color: '#fff' }}
                                                onClick={() => setCreateLabModalOpen(true)}
                                                disabled={!newPreparacaoAlbum.editorReturnDate}
                                            >
                                                +
                                            </Button></InputGroup>
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup>
                                    <Label className="form-control-label" htmlFor="laboratoryDeliveryDate">
                                        Entrega no Laboratório
                                    </Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="date"
                                        name="laboratoryDeliveryDate"
                                        id="laboratoryDeliveryDate"
                                        value={newPreparacaoAlbum.laboratoryDeliveryDate?.toString() || ""}
                                        onChange={handleCreateInputChange}
                                        disabled={!newPreparacaoAlbum.editorReturnDate}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup>
                                    <Label className="form-control-label" htmlFor="laboratoryReturnDate">
                                        Retorno do Laboratório
                                    </Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="date"
                                        name="laboratoryReturnDate"
                                        id="laboratoryReturnDate"
                                        value={newPreparacaoAlbum.laboratoryReturnDate?.toString() || ""}
                                        onChange={handleCreateInputChange}
                                        disabled={newPreparacaoAlbum.laboratorioId === 0}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-control-label" htmlFor="numberOfPhotosLaboratory">
                                        Nº de Fotos do Laboratório
                                    </Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="number"
                                        name="numberOfPhotosLaboratory"
                                        id="numberOfPhotosLaboratory"
                                        value={newPreparacaoAlbum.numberOfPhotosLaboratory}
                                        onChange={handleCreateInputChange}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-control-label" htmlFor="numberOfAlbums">
                                        Nº de Álbuns do Laboratório
                                    </Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="number"
                                        name="numberOfAlbums"
                                        id="numberOfAlbums"
                                        value={newPreparacaoAlbum.numberOfAlbums}
                                        onChange={handleCreateInputChange}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row className="mt-4">
                            <Col md="12">
                                <div style={{ border: '1px solid #ccc', borderRadius: 10, padding: 15, boxShadow: '0 2px 6px rgba(0,0,0,0.1)' }}>
                                    <h5 className="mb-3">Kits Disponíveis</h5>
                                    <Row>
                                        <Col md="4">
                                            <FormGroup check>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        name="kit30x60"
                                                        checked={newPreparacaoAlbum.kit30x60}
                                                        onChange={handleCreateInputChange}
                                                    />{' '}
                                                    Kit 30x60
                                                </Label>
                                                <Input
                                                    className="form-control-alternative mt-2"
                                                    type="number"
                                                    name="kit30x60Quantities"
                                                    value={newPreparacaoAlbum.kit30x60Quantities}
                                                    onChange={handleCreateInputChange}
                                                    placeholder="Quantidade"
                                                    disabled={!newPreparacaoAlbum.kit30x60}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="4">
                                            <FormGroup check>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        name="kit10x15"
                                                        checked={newPreparacaoAlbum.kit10x15}
                                                        onChange={handleCreateInputChange}
                                                    />{' '}
                                                    Kit 10x15
                                                </Label>
                                                <Input
                                                    className="form-control-alternative mt-2"
                                                    type="number"
                                                    name="kit10x15Quantities"
                                                    value={newPreparacaoAlbum.kit10x15Quantities}
                                                    onChange={handleCreateInputChange}
                                                    placeholder="Quantidade"
                                                    disabled={!newPreparacaoAlbum.kit10x15}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="4">
                                            <FormGroup check>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        name="kit28x35"
                                                        checked={newPreparacaoAlbum.kit28x35}
                                                        onChange={handleCreateInputChange}
                                                    />{' '}
                                                    Kit 28x35
                                                </Label>
                                                <Input
                                                    className="form-control-alternative mt-2"
                                                    type="number"
                                                    name="kit28x35Quantities"
                                                    value={newPreparacaoAlbum.kit28x35Quantities}
                                                    onChange={handleCreateInputChange}
                                                    placeholder="Quantidade"
                                                    disabled={!newPreparacaoAlbum.kit28x35}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                        <div className="d-flex justify-content-end mt-3">
                            <Button
                                style={{ color: "#FFF", backgroundColor: "#585858" }}
                                type="submit"
                                size="m"
                            >
                                Criar Preparação
                            </Button>
                            <Button
                                style={{ color: "#FFF", backgroundColor: "#d9534f" }}
                                className="ml-2"
                                onClick={() => { setCreateModalOpen(false); getPreparacaoAlbumPaged(1, objUserTk.EmpresaId, 0, 9); }}
                                size="m"
                            >
                                Cancelar
                            </Button>
                        </div>
                    </Form>
                </ModalBody>
            </Modal >

            <Modal isOpen={editModalOpen} toggle={() => setEditModalOpen(!editModalOpen)} backdrop="static" size="xl">
                <ModalHeader toggle={() => setEditModalOpen(!editModalOpen)}>Editar Preparação de Álbum</ModalHeader>
                <ModalBody>
                    {editingPreparacaoAlbum && (
                        <Form onSubmit={handleEditSubmit}>
                            <Row>
                                <Col md="12">
                                    <FormGroup>
                                        <Label className="form-control-label" htmlFor="description">
                                            Descrição
                                        </Label>
                                        <Input
                                            className="form-control-alternative"
                                            type="text"
                                            name="description"
                                            id="description"
                                            value={editingPreparacaoAlbum.description}
                                            onChange={handleEditInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="12">
                                    <FormGroup>
                                        <Label className="form-control-label" htmlFor="cursoBadge">
                                            Cursos vinculados
                                        </Label>
                                        <div className="mt-2" id="cursoBadge">
                                            {editingPreparacaoAlbum.cursos?.map((curso) => (
                                                <span key={curso.id} className="badge badge-primary mr-2">
                                                    {curso.name}
                                                </span>
                                            ))}
                                        </div>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="4">
                                    <FormGroup>
                                        <Label className="form-control-label" htmlFor="editorId">
                                            Editor
                                        </Label>
                                        <InputGroup>
                                            <Input
                                                className="form-control-alternative"
                                                type="select"
                                                name="editorId"
                                                id="editorId"
                                                value={editingPreparacaoAlbum.editorId}
                                                onChange={handleEditInputChange}
                                            >
                                                <option value={0}>Selecione um Editor</option>
                                                {listEditor.map((editor) => (
                                                    <option key={editor.id} value={editor.id}>
                                                        {editor.name}
                                                    </option>
                                                ))}
                                            </Input><Button
                                                    style={{ background: '#585858', color: '#fff' }}
                                                    onClick={() => setCreateEditorModalOpen(true)}
                                                >
                                                    +
                                                </Button></InputGroup>
                                    </FormGroup>
                                </Col>
                                <Col md="4">
                                    <FormGroup>
                                        <Label className="form-control-label" htmlFor="editorDeliveryDate">
                                            Entrega para o editor
                                        </Label>
                                        <Input
                                            className="form-control-alternative"
                                            type="date"
                                            name="editorDeliveryDate"
                                            id="editorDeliveryDate"
                                            value={editingPreparacaoAlbum.editorDeliveryDate?.toString() || ""}
                                            onChange={handleEditInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="4">
                                    <FormGroup>
                                        <Label className="form-control-label" htmlFor="editorReturnDate">
                                            Retorno do Editor
                                        </Label>
                                        <Input
                                            className="form-control-alternative"
                                            type="date"
                                            name="editorReturnDate"
                                            id="editorReturnDate"
                                            value={editingPreparacaoAlbum.editorReturnDate?.toString() || ""}
                                            onChange={handleEditInputChange}
                                            disabled={editingPreparacaoAlbum.editorId === 0}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="12">
                                    <FormGroup>
                                        <Label className="form-control-label" htmlFor="numberOfPhotos">
                                            Nº de Fotos do Editor
                                        </Label>
                                        <Input
                                            className="form-control-alternative"
                                            type="number"
                                            name="numberOfPhotos"
                                            id="numberOfPhotos"
                                            value={editingPreparacaoAlbum.numberOfPhotos}
                                            onChange={handleEditInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="4">
                                    <FormGroup>
                                        <Label className="form-control-label" htmlFor="laboratorioId">
                                            Laboratório
                                        </Label>
                                        <InputGroup>
                                            <Input
                                                className="form-control-alternative"
                                                type="select"
                                                name="laboratorioId"
                                                id="laboratorioId"
                                                value={editingPreparacaoAlbum.laboratorioId}
                                                onChange={handleEditInputChange}
                                                disabled={!editingPreparacaoAlbum.editorReturnDate}
                                            >
                                                <option value={0}>Selecione um Laboratório</option>
                                                {listLaboratory.map((lab) => (
                                                    <option key={lab.id} value={lab.id}>
                                                        {lab.name}
                                                    </option>
                                                ))}
                                            </Input><Button
                                                    style={{ background: '#585858', color: '#fff' }}
                                                    onClick={() => setCreateLabModalOpen(true)}
                                                    disabled={!editingPreparacaoAlbum.editorReturnDate}
                                                >
                                                    +
                                                </Button></InputGroup>
                                    </FormGroup>
                                </Col>
                                <Col md="4">
                                    <FormGroup>
                                        <Label className="form-control-label" htmlFor="laboratoryDeliveryDate">
                                            Entrega no Laboratório
                                        </Label>
                                        <Input
                                            className="form-control-alternative"
                                            type="date"
                                            name="laboratoryDeliveryDate"
                                            id="laboratoryDeliveryDate"
                                            value={editingPreparacaoAlbum.laboratoryDeliveryDate?.toString() || ""}
                                            onChange={handleEditInputChange}
                                            disabled={!editingPreparacaoAlbum.editorReturnDate}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="4">
                                    <FormGroup>
                                        <Label className="form-control-label" htmlFor="laboratoryReturnDate">
                                            Retorno do Laboratório
                                        </Label>
                                        <Input
                                            className="form-control-alternative"
                                            type="date"
                                            name="laboratoryReturnDate"
                                            id="laboratoryReturnDate"
                                            value={editingPreparacaoAlbum.laboratoryReturnDate?.toString() || ""}
                                            onChange={handleEditInputChange}
                                            disabled={editingPreparacaoAlbum.laboratorioId === 0}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="6">
                                    <FormGroup>
                                        <Label className="form-control-label" htmlFor="numberOfPhotosLaboratory">
                                            Nº de Fotos do Laboratório
                                        </Label>
                                        <Input
                                            className="form-control-alternative"
                                            type="number"
                                            name="numberOfPhotosLaboratory"
                                            id="numberOfPhotosLaboratory"
                                            value={editingPreparacaoAlbum.numberOfPhotosLaboratory}
                                            onChange={handleEditInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <Label className="form-control-label" htmlFor="numberOfAlbums">
                                            Nº de Álbuns do Laboratório
                                        </Label>
                                        <Input
                                            className="form-control-alternative"
                                            type="number"
                                            name="numberOfAlbums"
                                            id="numberOfAlbums"
                                            value={editingPreparacaoAlbum.numberOfAlbums}
                                            onChange={handleEditInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="4">
                                    <FormGroup>
                                        <Label className="form-control-label" htmlFor="status">
                                            Status do Álbum
                                        </Label>
                                        <Input
                                            className="form-control-alternative"
                                            type="select"
                                            name="status"
                                            id="status"
                                            value={editingPreparacaoAlbum.status}
                                            onChange={handleEditInputChange}
                                            disabled
                                        >
                                            <option value={0}>Selecione...</option>
                                            <option value={1}>Aberto</option>
                                            <option value={2}>Em andamento</option>
                                            <option value={3}>Em edição</option>
                                            <option value={4}>Em laboratório</option>
                                            <option value={5}>Finalizado</option>
                                        </Input>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row className="mt-4">
                                <Col md="12">
                                    <div style={{ border: '1px solid #ccc', borderRadius: 10, padding: 15, boxShadow: '0 2px 6px rgba(0,0,0,0.1)' }}>
                                        <h5 className="mb-3">Kits Disponíveis</h5>
                                        <Row>
                                            <Col md="4">
                                                <FormGroup check>
                                                    <Label check>
                                                        <Input
                                                            type="checkbox"
                                                            name="kit30x60"
                                                            checked={editingPreparacaoAlbum.kit30x60}
                                                            onChange={handleEditInputChange}
                                                        />{' '}
                                                        Kit 30x60
                                                    </Label>
                                                    <Input
                                                        className="form-control-alternative mt-2"
                                                        type="number"
                                                        name="kit30x60Quantities"
                                                        value={editingPreparacaoAlbum.kit30x60Quantities}
                                                        onChange={handleEditInputChange}
                                                        placeholder="Quantidade"
                                                        disabled={!editingPreparacaoAlbum.kit30x60}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md="4">
                                                <FormGroup check>
                                                    <Label check>
                                                        <Input
                                                            type="checkbox"
                                                            name="kit10x15"
                                                            checked={editingPreparacaoAlbum.kit10x15}
                                                            onChange={handleEditInputChange}
                                                        />{' '}
                                                        Kit 10x15
                                                    </Label>
                                                    <Input
                                                        className="form-control-alternative mt-2"
                                                        type="number"
                                                        name="kit10x15Quantities"
                                                        value={editingPreparacaoAlbum.kit10x15Quantities}
                                                        onChange={handleEditInputChange}
                                                        placeholder="Quantidade"
                                                        disabled={!editingPreparacaoAlbum.kit10x15}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md="4">
                                                <FormGroup check>
                                                    <Label check>
                                                        <Input
                                                            type="checkbox"
                                                            name="kit28x35"
                                                            checked={editingPreparacaoAlbum.kit28x35}
                                                            onChange={handleEditInputChange}
                                                        />{' '}
                                                        Kit 28x35
                                                    </Label>
                                                    <Input
                                                        className="form-control-alternative mt-2"
                                                        type="number"
                                                        name="kit28x35Quantities"
                                                        value={editingPreparacaoAlbum.kit28x35Quantities}
                                                        onChange={handleEditInputChange}
                                                        placeholder="Quantidade"
                                                        disabled={!editingPreparacaoAlbum.kit28x35}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                            <div className="d-flex justify-content-end mt-3">
                                <Button
                                    style={{ color: "#FFF", backgroundColor: "#585858" }}
                                    type="submit"
                                    size="m"
                                >
                                    Salvar alterações
                                </Button>
                                <Button
                                    style={{ color: "#FFF", backgroundColor: "#d9534f" }}
                                    className="ml-2"
                                    onClick={() => setEditModalOpen(false)}
                                    size="m"
                                >
                                    Cancelar
                                </Button>
                            </div>
                        </Form>
                    )}
                </ModalBody>
            </Modal>

            <CreateTerceiroModal
                isOpen={createEditorModalOpen}
                toggle={() => setCreateEditorModalOpen(false)}
                fixedTipoTerceiroId={12}              // 3 = Editor
                onCreated={() => {
                    handleGetEditorsByEmpresa(objUserTk.EmpresaId);
                    setCreateEditorModalOpen(false);
                }}
            />

            <CreateTerceiroModal
                isOpen={createLabModalOpen}
                toggle={() => setCreateLabModalOpen(false)}
                fixedTipoTerceiroId={14}              // 4 = Laboratório
                onCreated={() => {
                    handleGetLaboratoriesByEmpresa(objUserTk.EmpresaId);
                    setCreateLabModalOpen(false);
                }}
            />

        </>
    );
};

export default PreparacaoAlbum;